export { SkyPageSummaryKeyInfoComponent } from './page-summary-key-info.component';
